export default "__VITE_ASSET__CJJV95XE__"